<!-- eslint-disable @angular-eslint/template/elements-content -->
<div class="full-width-container">
  <app-main-toolbar class="main-toolbar"></app-main-toolbar>

  <app-left-toolbar *ngIf="isDraftState()" class="left-toolbar"></app-left-toolbar>

  <mat-drawer-container class="asides-container">
    <mat-drawer-content class="canvas-container" [ngClass]="{expanded: (expanded$ | async)}">
      <app-diagram-canvas></app-diagram-canvas>

      <q9-page-loader [isLoading]="spinnerService.spinnerState().show"></q9-page-loader>

      <app-generation-progress-button
        *ngIf="storyGenerationStatus$ | async as aiStoryGenerationStatus"
        class="generation-status"
        [generationStatus]="aiStoryGenerationStatus"></app-generation-progress-button>

      <app-recommendations-generation-status
        *ngIf="recommendationsUPNGenerationProgress$ | async as recommendationsGenerationProgress"
        [recommendationsGenerationProgress]="
          recommendationsGenerationProgress
        "></app-recommendations-generation-status>

      <app-recommendations-generation-status
        *ngIf="
          recommendationsAgentInstructionsGenerationProgress$
            | async as recommendationsAgentInstructionsGenerationProgress
        "
        [recommendationsGenerationProgress]="
          recommendationsAgentInstructionsGenerationProgress
        "></app-recommendations-generation-status>

      <app-recommendations-generation-status
        *ngIf="
          recommendationsAgentFinderGenerationProgress$
            | async as recommendationsAgentFinderGenerationProgress
        "
        [recommendationsGenerationProgress]="
          recommendationsAgentFinderGenerationProgress
        "></app-recommendations-generation-status>

      <app-dv-generation-status
        *ngIf="generationProgressService.dvGenerationStatus$ | async as dvGenerationStatus"
        [status]="dvGenerationStatus"></app-dv-generation-status>
    </mat-drawer-content>

    <mat-drawer
      #rightSidebar
      class="right-sidebar"
      [autoFocus]="false"
      [hidden]="!(expanded$ | async)"
      [ngClass]="{
        'upn-sidebar': !isArchitecture() || !sfaHeaderSvc.isPinned,
        'sfa-sidebar': isArchitecture() && sfaHeaderSvc.isPinned
      }"
      [disableClose]="true"
      mode="over"
      position="end">
      <ng-container *ngIf="{inProgress: dvGenerationInProgress$ | async} as dvGeneration">
        <button
          class="tool-btn bar-expand-hr"
          [disabled]="dvGeneration.inProgress"
          [ngClass]="{expanded: rightSidebar.opened, disabled: dvGeneration.inProgress}"
          [matTooltip]="'TOOLBAR.OPEN_RIGHT' | translate"
          matTooltipPosition="left"
          tabindex="-1"
          (click)="toggleRight()"></button>
      </ng-container>
      <div class="right-sidebar-inner" [ngClass]="{'margin-left': !rightSidebar.opened}">
        <ng-template #lazy></ng-template>
      </div>
    </mat-drawer>
  </mat-drawer-container>

  <app-bottom-toolbar
    class="bottom-toolbar"
    [ngClass]="{opened: rightSidebar.opened, closed: !rightSidebar.opened}"></app-bottom-toolbar>
</div>
